import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'spark-core-dx/components';

const DataDomain = () => {
  return (
    <Layout layoutOverride="standard">
      <Outlet />
    </Layout>
  );
};

export default DataDomain;
